import React from 'react'
import SelectChairColor from '../select-chair-color/SelectChairColor'
import SelectPillowColor from '../select-chair-color/SelectPillowColor'
import ManagePillow from '../select-chair-color/ManagePillow'
import ChairBack from '../select-chair-color/ChairBack'
import { Transition } from '@headlessui/react'
import { useSnapshot } from 'valtio'
import CustomizerContext from '../CustomizerContext'

import {ReactComponent as BrandLogo} from '../j4clogo.svg';


const SidebarLayout = (props) => {

    const snap = useSnapshot(CustomizerContext)

    return(

        <>
        <div className="mb-5 bg-gray-800 rounded bg-opacity-95 flex lg:pl-24 xl:pl-0">
            <BrandLogo className="m-2" />
            <div className="font-bold text-sm text-gray-50 pl-4 pt-4" >
            Old style chair
            <p className="text-sm text-gray-400 antialiased">Customizer</p>
            </div>
        </div>


        <div className="space-y-0 pt-5 bg-gray-800 bg-opacity-95 pl-8 pr-8 pb-20 rounded text-gray-50">
        
            <SelectChairColor />
            <ChairBack />
            <ManagePillow />

            <div className="h-24">
            &#8203;
                <Transition
                        show={snap.pillow.visible}
                        enter="transition-opacity duration-155"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity duration-150"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0" >
                            <SelectPillowColor />
                </Transition>
            </div>
        </div>

        </>

       
    )


}

export default SidebarLayout